function MoreParticipants() {
    return (
        <div className="text-center font-bold text-gray-dark text-lg 2xl:text-2xl">
            ...
        </div>
    );
}

export default MoreParticipants;
